var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "clearfix main_center" }, [
    _c("div", { staticClass: "top-content busWinessLeft" }, [
      _c(
        "div",
        { staticClass: "left-navbar" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.back()
                },
              },
            },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading.lock",
            value: _vm.fullscreenLoading,
            expression: "fullscreenLoading",
            modifiers: { lock: true },
          },
        ],
        staticClass: "right-content clearfix busWinessRight",
      },
      [
        _c("div", { staticClass: "item_top" }, [
          _c("div", { staticClass: "item_top_title" }, [
            _vm.dataInfo.bidSectionCode
              ? _c("span", { staticClass: "title" }, [
                  _vm._v("[" + _vm._s(_vm.dataInfo.bidSectionCode) + "] "),
                ])
              : _vm._e(),
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.dataInfo.bidSectionName)),
            ]),
            _vm.dataInfo.qualificationModeName
              ? _c("span", { staticClass: "tag" }, [
                  _vm._v(_vm._s(_vm.dataInfo.qualificationModeName)),
                ])
              : _vm._e(),
            _vm.dataInfo.tenderModeName
              ? _c("span", { staticClass: "tag" }, [
                  _vm._v(_vm._s(_vm.dataInfo.tenderModeName)),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "my_padding" }, [
          _c("div", { staticClass: "item_middle" }, [
            _c("div", [
              _c("p", [
                _c("span", { staticClass: "item_subtitle" }, [
                  _vm._v("审核部门："),
                ]),
                _c("span", { staticClass: "content" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("projectIsEmpty")(_vm.dataInfo.approveDeptName)
                    )
                  ),
                ]),
              ]),
              _c("p", [
                _c("span", { staticClass: "item_subtitle" }, [
                  _vm._v("招标单位："),
                ]),
                _c("span", { staticClass: "content" }, [
                  _vm._v(
                    _vm._s(_vm._f("projectIsEmpty")(_vm.dataInfo.tendererName))
                  ),
                ]),
              ]),
            ]),
            _c("div", [
              _c("p", [
                _c("span", { staticClass: "item_subtitle" }, [
                  _vm._v("监督部门："),
                ]),
                _c("span", { staticClass: "content" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("projectIsEmpty")(_vm.dataInfo.superviseDeptName)
                    )
                  ),
                ]),
              ]),
              _c("p", [
                _c("span", { staticClass: "item_subtitle" }, [
                  _vm._v("招标代理："),
                ]),
                _c("span", { staticClass: "content" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("projectIsEmpty")(_vm.dataInfo.tenderAgencyName)
                    )
                  ),
                ]),
              ]),
            ]),
            _c("div", [
              _c("p", [
                _c("span", { staticClass: "item_subtitle" }, [
                  _vm._v("开标时间："),
                ]),
                _c("span", { staticClass: "content" }, [
                  _vm._v(
                    _vm._s(_vm._f("projectIsEmpty")(_vm.dataInfo.openTime)) +
                      " "
                  ),
                  _vm.dataInfo.passOpenDate > 0 ? _c("div") : _vm._e(),
                  _vm.dataInfo.passOpenDate > 0
                    ? _c("i", [
                        _vm._v(
                          _vm._s(
                            _vm.dataInfo.passOpenDate == 0
                              ? "今日开标"
                              : _vm.dataInfo.passOpenDate > 0
                              ? _vm.dataInfo.passOpenDate + "天后"
                              : ""
                          )
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c("p"),
            ]),
            _c("div", [
              _c("span", [
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "130px",
                      "text-align": "right",
                      "margin-bottom": "5px",
                    },
                  },
                  [_vm._v("时长")]
                ),
                _c("br"),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "text-align": "right",
                      width: "130px",
                      "font-size": "20px",
                      color: "#000",
                      "font-weight": "500",
                      display: "inline-block",
                    },
                  },
                  [_vm._v("历时 " + _vm._s(_vm.dataInfo.passDate) + " 天")]
                ),
              ]),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "item_bottom" },
          [
            _vm._m(0),
            _vm._l(_vm.dataInfo.flownodeList, function (item, index) {
              return _c(
                "el-card",
                {
                  key: index,
                  staticClass: "box-card",
                  staticStyle: { "margin-bottom": "10px" },
                },
                [
                  _c("div", { staticClass: "line" }, [_c("div")]),
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v(_vm._s(item.nodeName))])]
                  ),
                  _c("flowCard", {
                    attrs: { itemData: item, cardWidth: _vm.cardWidth },
                  }),
                ],
                1
              )
            }),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "radioBox" }, [
      _c("div", [
        _c("span", { staticStyle: { background: "#1890FF" } }),
        _vm._v("未超出操作时效范围"),
      ]),
      _c("div", [
        _c("span", { staticStyle: { background: "#ffc500" } }),
        _vm._v("快要超出操作时效范围"),
      ]),
      _c("div", [
        _c("span", { staticStyle: { background: "#FF9900" } }),
        _vm._v("即将超出操作时效范围"),
      ]),
      _c("div", [
        _c("span", { staticStyle: { background: "#F23030" } }),
        _vm._v("已超出操作时效范围"),
      ]),
      _c("div", [
        _c("span", { staticStyle: { background: "#FFFFFF" } }),
        _vm._v("未到该操作环节"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }